// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bNRGBmFvx0IrYEoSLrKT{padding-left:12px}.MccQ0magaDgETYcG5FOH{margin-bottom:8px}.Pi0DlNkT9nkhggkZO0Tq{margin-top:24px}.Y24cLYzkFN098Rrj_z4s{padding:11px 8px 11px 12px}.Y24cLYzkFN098Rrj_z4s>div{white-space:nowrap;text-overflow:ellipsis;display:block;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textInput": `bNRGBmFvx0IrYEoSLrKT`,
	"zipInput": `MccQ0magaDgETYcG5FOH`,
	"countrySelectWrap": `Pi0DlNkT9nkhggkZO0Tq`,
	"countriesSelect": `Y24cLYzkFN098Rrj_z4s`
};
export default ___CSS_LOADER_EXPORT___;
